import { ShippingPlan } from "@deliverr/inbound-client";
import { PrepJobResponse } from "@deliverr/prep-service-client";
import { OrderResponse } from "@deliverr/replenishment-client";
import { createActionCreator } from "common/ReduxUtils";
import { PrepDetailsActionTypes } from "prep/types/details/PrepDetailsActionTypes";

export const setPrepDetails = createActionCreator<PrepJobResponse>(PrepDetailsActionTypes.SET_PREP_DETAILS, "details");

export const setSourcePlanDetails = createActionCreator<ShippingPlan>(
  PrepDetailsActionTypes.SET_SOURCE_PLAN_DETAILS,
  "sourcePlanDetails"
);

export const setSourceOrderDetails = createActionCreator<OrderResponse>(
  PrepDetailsActionTypes.SET_SOURCE_ORDER_DETAILS,
  "sourceOrderDetails"
);

export const setPricingError = createActionCreator<boolean>(
  PrepDetailsActionTypes.SET_PRICING_ERROR,
  "hasPricingError"
);

export const resetPrepDetails = createActionCreator(PrepDetailsActionTypes.RESET_DETAILS);

export const resetPrepDetailsWithArchived = createActionCreator(PrepDetailsActionTypes.RESET_DETAILS_WITH_ARCHIVED);
